@if (pwaInstall.visible()) {
  <div
    class="pwa-install-popup"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pwa-install-title"
  >
    <button
      type="button"
      class="pwa-install-popup__backdrop"
      aria-label="Dismiss install popup"
      (click)="pwaInstall.dismiss()"
    ></button>
    <section class="pwa-install-popup__card">
      <header class="pwa-install-popup__header">
        <inq-logo [size]="40" />
        <button
          type="button"
          class="pwa-install-popup__close"
          aria-label="Close"
          (click)="pwaInstall.dismiss()"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </header>
      <h2 id="pwa-install-title">Install Indiqare Admin</h2>
      @if (pwaInstall.showManualInstructions()) {
        <p>
          @if (pwaInstall.iosDevice()) {
            Tap Share, then Add to Home Screen.
          } @else {
            Open the browser menu and choose Install app.
          }
        </p>
      } @else {
        <p>Install this app for quicker access and a full-screen experience.</p>
      }
      <div class="pwa-install-popup__actions">
        <button mat-button type="button" (click)="pwaInstall.dismiss()">
          {{ pwaInstall.showManualInstructions() ? 'Got it' : 'Not now' }}
        </button>
        @if (!pwaInstall.showManualInstructions()) {
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="pwaInstall.install()"
            [disabled]="pwaInstall.installing()"
          >
            {{ pwaInstall.installing() ? 'Installing…' : 'Install' }}
          </button>
        }
      </div>
    </section>
  </div>
}

@if (swUpdate.updating()) {
  <div class="app-update-overlay" role="status" aria-live="polite">
    <mat-icon class="app-update-overlay__icon" aria-hidden="true">system_update</mat-icon>
    <span>Updating app…</span>
  </div>
}

@if (swUpdate.updateAvailable()) {
  <div class="app-update-shell" role="dialog" aria-modal="true" aria-labelledby="app-update-title">
    <div class="app-update-banner">
      <mat-icon class="app-update-banner__icon" aria-hidden="true">system_update</mat-icon>
      <div class="app-update-banner__copy">
        <p class="app-update-banner__title" id="app-update-title">New version available</p>
        <p class="app-update-banner__text">A new version is available. Reload to update.</p>
      </div>
      <div class="app-update-banner__actions">
        <button mat-button type="button" (click)="swUpdate.dismiss()">Later</button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="swUpdate.applyUpdate()"
          [disabled]="swUpdate.updating()"
        >
          {{ swUpdate.updating() ? 'Updating…' : 'Reload' }}
        </button>
      </div>
    </div>
  </div>
}

<router-outlet />
